import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// react
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
// components
import { Button, Container, Title } from "../../atoms";
import { ConversationCard } from "../../molecules/ConversationCard/ConversationCard";
export const ConversationList = ({ accountID, chats, onCreateChat, }) => {
    // hooks
    const navigate = useNavigate();
    return (_jsxs(Container, Object.assign({ size: 'lg' }, { children: [_jsxs(Header, { children: [_jsx(StyledTitle, Object.assign({ size: 'sm' }, { children: "Chats" })), _jsx(Button, Object.assign({ ariaLabel: 'new chat', iconLeft: 'plus', size: 'sm', onPress: () => {
                            onCreateChat();
                        } }, { children: "New chat" }))] }), _jsx(ListWrapper, { children: chats.map((chat) => {
                    var _a;
                    return (_jsx(ChatItem, Object.assign({ onClick: () => navigate(`/messenger/${chat.id}`) }, { children: _jsx(ConversationCard, { accountID: accountID, messages: chat.messages, createdAt: ((_a = chat.messages) === null || _a === void 0 ? void 0 : _a[0].formattedCreatedAt) || '' }) }), chat.id));
                }) })] })));
};
const ListWrapper = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.spacing[8]};
  padding: ${(props) => props.theme.spacing[16]} 0;
`;
const Header = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: ${(props) => props.theme.spacing[16]};
`;
const StyledTitle = styled(Title) `
  margin: 0;
`;
const ChatItem = styled.div `
  cursor: pointer;
  transition: transform 0.2s ease;

  &:hover {
    transform: translateX(4px);
  }
`;
ConversationList.displayName = 'ConversationList';
export default ConversationList;
